import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.isfmaccess && _vm.isfmaccess.id ? _c(VHover, {
    attrs: {
      "open-delay": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function ({
        hover
      }) {
        return [_c(VCard, {
          staticClass: "mx-auto fav-dtwin-card grey-border",
          style: _vm.tileSizeSetting == 1 ? 'height: 482px; max-height: 482px;' : 'height: 340px; max-height: 340px;',
          attrs: {
            "elevation": hover ? 4 : 0,
            "min-width": "240",
            "outlined": ""
          }
        }, [_c('div', {
          staticStyle: {
            "height": "153px"
          }
        }, [_c(VAvatar, {
          staticClass: "mx-auto d-block mt-8",
          attrs: {
            "slot": "offset",
            "size": "140"
          },
          on: {
            "click": function ($event) {
              return _vm.processDoor(_vm.isfmaccess.id);
            }
          },
          slot: "offset"
        }, [_c(VIcon, {
          style: _vm.avatarLoader ? 'opacity: 0.3' : '',
          attrs: {
            "color": _vm.avatarLoader ? 'grey' : _vm.color,
            "size": "120"
          }
        }, [_vm._v("\n          fal fa-unlock-alt\n        ")]), _vm.avatarLoader ? _c(VProgressCircular, {
          staticStyle: {
            "margin-top": "-150px"
          },
          attrs: {
            "rotate": 360,
            "size": 120,
            "width": 15,
            "value": _vm.value,
            "color": "success"
          }
        }, [_c('span', {
          staticClass: "transponder"
        }, [_vm._v(_vm._s(_vm.$i18n_t('Common.activating')) + "...")])]) : _vm._e()], 1)], 1), _c(VCardText, {
          class: `fav-tiles${_vm.dsize} pt-0 mt-2`
        }, [_vm._v("\n      " + _vm._s(_vm.$i18n_t('IS.FM.AccessMgmt.keyTileHint')) + "\n      "), _c('br'), _vm._v("\n      " + _vm._s(_vm.isfmaccess.accessObjectData.title) + "\n      "), _c(VIcon, {
          attrs: {
            "small": "",
            "color": _vm.color
          }
        }, [_vm._v("fal fa-arrow-circle-right")]), _vm._v("\n      " + _vm._s(_vm.keyTwinTitle(_vm.isfmaccess)) + "\n    ")], 1)], 1)];
      }
    }], null, false, 3214101268)
  }) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };